module.exports = __webpack_public_path__ + "media/images/s03_01_en-b4377cccdc69bec1cd979a5073db3237.svg";